import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateScrollingMargin } from '../../modules/comparePageScrolling';
import WindowEventListener from '../WindowEventListener';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

class SetScrollingMargin extends Component {
  receiveMessage = ({ origin, data: { type, payload } }) => {
    const { dispatch } = this.props;
    const matchURL = /https?:\/\/+([a-z])*\.*([a-z])*\.*(isf)+\.*[io]*(com)*/;
    if (type === 'SET_SCROLLING_REQUEST') {
      if (origin.match(matchURL) && payload !== undefined) {
        dispatch(updateScrollingMargin(payload));
      }
    }
  }

  render() {
    return <WindowEventListener event="message" onEvent={this.receiveMessage} />;
  }
}

SetScrollingMargin.propTypes = propTypes;

export default connect()(SetScrollingMargin);
